import * as Api from '@ViewModels';
import { StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { useParams } from 'react-router';
import { useFullscreenModal } from '../../../models/hooks/appStateHooks';
import { useAIConversationFilterQuery } from '../../../queries/AIConversation/useAIConversationFilterQuery';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';

const s = StyleSheet.create({
	root: {
		display: 'flex',
		justifyContent: 'center',
	},
});

export function CopyMageLatestConversationPage() {
	const { accountId } = useParams<{ accountId: string }>();
	const fullscreenModal = useFullscreenModal();
	const impersonationContext: Api.IImpersonationContext = { account: { id: accountId } };
	const aiConversationFilterQuery = useAIConversationFilterQuery({
		impersonationContext,
		filter: {
			criteria: [
				{
					property: Api.AIConversationFilterProperty.ConversationType,
					value: Api.AIConversationType.CopyMage,
				},
			],
		},
	});

	React.useEffect(() => {
		if (!aiConversationFilterQuery.isFetching && aiConversationFilterQuery.data) {
			const lastConversation = aiConversationFilterQuery.data?.[0];
			if (lastConversation) {
				fullscreenModal.history.push(`/copymage/${accountId}/conversation/${lastConversation.id}`);
			} else {
				fullscreenModal.history.push(`/copymage/${accountId}/conversation`);
			}
		}
	}, [aiConversationFilterQuery.data, fullscreenModal, aiConversationFilterQuery.isFetching, accountId]);

	if (aiConversationFilterQuery.isFetching || !aiConversationFilterQuery.data) {
		return (
			<div className={css(s.root)}>
				<LoadingSpinner />
			</div>
		);
	}

	return null;
}
